import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#F0EDEB]" data-id="element-185">
      <div className="max-w-3xl mx-auto px-6" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-187">
          <div className="text-center mb-12" data-id="element-188">
            <div className="inline-flex items-center gap-2 bg-[#722F37]/10 text-[#722F37] border border-[#722F37]/30 px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-189">
              <SparklesIcon className="w-4 h-4" data-id="element-190" />
              El Mecanismo Único
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-6" data-id="element-191">
              El Contrato de Convivencia en Crisis (CCC)
            </h2>
          </div>

          <div className="relative" data-id="element-192">
            {/* Glow effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#722F37]/50 to-[#722F37]/10 rounded-2xl blur opacity-30" data-id="element-193"></div>

            <div className="relative bg-[#FFFFFF] rounded-2xl p-8 md:p-10 shadow-2xl border border-[#722F37]/30" data-id="element-194">
              <p className="text-lg md:text-xl leading-relaxed mb-6 text-[#6B7280]" data-id="element-195">
                Este no es un libro de consejos románticos genéricos. Es un{' '}
                <span className="font-bold text-[#722F37]" data-id="element-196">
                  sistema operativo de ayuda
                </span>{' '}
                que utiliza la comunicación no violenta aplicada a la economía
                doméstica.
              </p>

              <p className="text-lg md:text-xl leading-relaxed text-[#6B7280]" data-id="element-197">
                Vas a implementar un sistema de{' '}
                <span className="font-bold text-[#2D2D2D]" data-id="element-198">
                  "Tablero Logístico"
                </span>{' '}
                para que los problemas de dinero se resuelvan en{' '}
                <span className="text-[#722F37] font-semibold" data-id="element-199">
                  20 minutos semanales
                </span>
                , devolviéndole a tu habitación la paz que perdió hace meses.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}